import { useState, useEffect, useContext, useRef } from "react";
import LoadingPanel from '../../LoadingPanel';
import Dialog from '../../dialogs/Dialog';
import Button from '../../buttons/Button';
import { buildUrl } from "../../utils/helper";
import UIGenerator from "../../uiGenerator/UIGenerator";
import { MetaContext } from '../../utils/withMeta';

const UiDesigner = (props) => {
  const meta = useContext(MetaContext);
  const { akc, showMsg, obj, selected } = props;
  const [schema, setSchema] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [newUI, setNewUI] = useState(null);
  const title = obj?.akc?.NAkc ?? "GUI";

  const ref = useRef(null);

  useEffect(() => {
    if (selected.length === 1) {
      setLoading(true);
      meta.getSchema(selected[0]?.NIdentif)
        .then(schema => {
          setSchema(schema);
          setLoading(false);
        })
        .catch(error => {
          showMsg(error, 'error');
          setLoading(false);
        });
    }
  }, [selected, isOpen]);

  useEffect(() => {
    if (schema?.Args && schema.Args?.ui) {
      setNewUI(schema.Args.ui);
    }
    else {
      setNewUI(null);
    }
  }, [schema]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = async () => {
    //volania meta pre ulozenie vygenerovanej schemy
    const isValid = ref.current?.validateUI();
    if (isValid) {
      setLoading(true);
      const primaryField = selected[0]?.NIdentif;
      meta.updateUI(primaryField, { ui: newUI })
        .then(() => {
          showMsg("Akcia prebehla", "ok");
        })
        .catch(error => {
          setNewUI(null);
          showMsg("Akcia neprebehla", 'error');
        });

      setLoading(false);
      handleClose();
    }
    else {
      showMsg("Dizajn nie je možné uložiť", "error");
    }
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        primary={true}
        disabled={selected?.length !== 1}
        imageUrl={buildUrl('assets/icons/toolbar/multiformat.svg')}
        title={title}
      />
      {isOpen && schema && <Dialog
        title={title}
        isOpen={isOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        className={"AkcUiDesigner"}
        level={1}
        // resizable={true}
        // modal={true}
        disableConfirmOnEnter={true}
        width={window.innerWidth * 93 / 100}
      >
        <UIGenerator ref={ref} detailSchema={schema.Detail} UI={newUI} setNewUI={setNewUI} primaryField={selected[0]?.NIdentif} componentFactory={obj.componentFactory} />
      </Dialog>}
      <LoadingPanel isLoading={isLoading} />
    </>
  );
};

export default UiDesigner;
